module.exports = __webpack_public_path__ + "static/img/musicwav_bg@2x.d3245c7e.png";